// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dJqhh","question":"styles_question__1YVEN","description":"styles_description__63Ur6"};